import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../components/navbar";
import Footer from "../components/footer";
import ScrollToTop from "../components/scroll-to-top";

import hero from "../assets/images/hero/pages.jpg";

import { blogData } from "../data/data";

export default function Blogs() {
  return (
    <>
      <Navbar />

      <section
        className="bg-half-170 d-table w-100"
        style={{
          backgroundImage: `url(${hero})`,
          backgroundPosition: "center",
        }}
      >
        <div className="bg-overlay bg-gradient-overlay"></div>
        <div className="container">
          <div className="row mt-5 justify-content-center">
            <div className="col-12">
              <div className="title-heading text-center">
                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">
                  Latest Articles
                </h5>
              </div>
            </div>
          </div>

          <div className="position-middle-bottom">
            <nav aria-label="breadcrumb" className="d-block">
              <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                <li className="breadcrumb-item">
                  <Link to="/">Tu Es Belle</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Blogs
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </section>

      <div className="position-relative">
        <div className="shape overflow-hidden text-white">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="row g-4">
            {blogData.map((item, index) => (
              <div className="col-lg-4 col-md-6 col-12" key={index}>
                <div className="blog position-relative overflow-hidden shadow rounded p-4 h-100">
                  {/* Press badge overlay on image */}
                  {item.type === "press" && (
                    <div
                      className="position-absolute"
                      style={{ top: 24, right: 24, zIndex: 2 }}
                    >
                      <span className="badge bg-danger px-2 py-1">
                        <i className="mdi mdi-newspaper me-1"></i>Press
                      </span>
                    </div>
                  )}

                  <div className="position-relative">
                    <div className="blog-image position-relative overflow-hidden rounded shadow">
                      <img
                        src={item.image}
                        className="img-fluid"
                        alt={item.title}
                      />
                    </div>

                    <div className="position-absolute top-100 start-0 translate-middle-y ms-2">
                      <p
                        className={`badge mb-0 ${
                          item.type === "press" ? "bg-danger" : "bg-primary"
                        }`}
                      >
                        {item.tag}
                      </p>
                    </div>
                  </div>

                  <div className="pt-4 d-flex flex-column">
                    {/* Source label for press */}
                    {item.type === "press" && (
                      <p className="text-muted small mb-1">
                        <i className="mdi mdi-newspaper-variant-outline me-1"></i>
                        As featured in <strong>{item.source}</strong> ·{" "}
                        {item.date}
                      </p>
                    )}

                    <Link
                      to={`/blog-detail/${item.id}/${item.url}`}
                      className="text-dark title h5"
                    >
                      {item.title}
                    </Link>

                    <p className="text-muted my-2">{item.desc}</p>

                    <Link
                      to={`/blog-detail/${item.id}/${item.url}`}
                      className="text-dark read-more mt-auto"
                    >
                      {item.type === "press" ? "View Feature" : "Read More"}{" "}
                      <i className="mdi mdi-chevron-right align-middle"></i>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </>
  );
}
